module.exports = __webpack_public_path__ + "img/landing.ea0f4653.svg";